
















import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class DataTableHeaderSortIcon extends ComponentVue {
  @Prop({
    type: String
  })
  order!: string

  onClickSort(): void {
    let newOrder
    switch (this.order) {
      case '':
        newOrder = 'asc'
        break
      case 'asc':
        newOrder = 'desc'
        break
      case 'desc':
        newOrder = 'asc'
        break
    }

    this.$emit('sort', newOrder)
  }
}
